module.exports = __webpack_public_path__ + "static/media/jandb.d6ff22d8.png";